exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newsletter[data-v-037748f6] {\n  margin: 0 40px;\n}\n.h3 h2[data-v-037748f6] {\n  font-size: 24px;\n}\n@media (min-width: 768px) and (max-width: 1200px){\n.button-outline[data-v-037748f6]{\n    min-width: 100%;\n}\n}\n@media (max-width: 768px) {\n.newsletter[data-v-037748f6] {\n    margin: 0 10px;\n    padding: 25px 0px !important;\n    min-height: 202px;\n}\n.h3[data-v-037748f6] {\n    font-size: 18px;\n    text-align: center;\n}\n.newsletter-button[data-v-037748f6] {\n    padding-top: 25px;\n    text-align: center;\n}\n}\n", ""]);

// exports
